import { iaRa } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

import { applyPhaseTitleOverrides, paymentMethods } from '../../lib/constants';
import { useLetter } from '../LetterContext';
import { isSelfPayPhase } from '../lib/helpers';

const Tile = ({ icon, title, caption }) => (
  <div className="flex h-fit min-h-10 flex-col justify-center rounded-lg border border-solid border-neutral-200 px-3 py-2.5">
    <div className="flex items-center gap-1.5">
      <Icon icon={icon} size={18} color="neutral" />
      <Typography variant="p" size="small" weight="semibold">
        {title}
      </Typography>
    </div>
    {caption && (
      <Typography variant="p" size="xs" color="neutral-600">
        {caption}
      </Typography>
    )}
  </div>
);

const PreviewMethodTiles = () => {
  const { config, activePhaseField } = useLetter();
  const activePhase = iaRa(config?.phases).find((p) => p.field === activePhaseField);
  const enabledFields = new Set(
    iaRa(config?.payment_methods)
      .filter((m) => m.in_person || m.remote)
      .map((m) => m.field)
  );

  const isSelfPay = isSelfPayPhase(activePhase);
  const visibleMethods = applyPhaseTitleOverrides(
    paymentMethods.filter((m) => enabledFields.has(m.id)),
    { isSelfPay }
  );

  return (
    <div className="flex flex-col gap-2 rounded-md">
      {visibleMethods.map((method) => (
        <Tile key={method.id} {...method} />
      ))}
    </div>
  );
};

export default PreviewMethodTiles;
